const spacesRegex = /\s+/g;
export const triggerHotjarCurrentView = (app, page) => window.hj && window.hj('event', `${app}-${page.replace(spacesRegex, '-')}`);
